'use client';

import { ReactNode } from 'react';

import { Box, Spacer, SpacerSize, Title, TitleLevels, View } from '@bytel/trilogy-react';

export function ImageCtaBox({
    children,
    backgroundImage,
    title,
    text,
    cta,
}: {
    children?: ReactNode;
    backgroundImage: string;
    title: string;
    text: string | ReactNode;
    cta: ReactNode;
}) {
    return (
        <Box className='is-paddingless' fullheight>
            <View className='gap-2 is-mobile is-vertical-mobile is-fullheight' flexable>
                <View style={{ flex: 1 }}>
                    <div
                        style={{
                            minHeight: '200px',
                            backgroundImage: `url(${backgroundImage})`,
                        }}
                        className='rounded-lg image-cta-box image-cover'
                    />
                </View>
                <View style={{ flex: 2 }}>
                    <Box shadowless fullheight className='is-justified-space-evenly'>
                        <Title level={TitleLevels.FOUR}>{title}</Title>
                        {text}
                        <Spacer size={SpacerSize.FOUR} />
                        {cta}
                    </Box>
                </View>
            </View>
            {children}
        </Box>
    );
}
